import React from "react";
import { EMPTY_STRING } from "../../../constants/global.constants";

const LabelValueDisplay = ({ label, value, className = EMPTY_STRING }) => {
  return (
    <div className={`col-12 col-sm-5 col-md-3 ${className}`}>
      <div className="customer-property">
        <div className="heading">{label}</div>
        <div className="value">{value}</div>
      </div>
    </div>
  );
};

export default LabelValueDisplay;
